/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTE0LjkyOTkgNy40OTk4Mkg4LjQ5OTk1VjEuMDY5ODJINy40OTk5NVY3LjQ5OTgySDEuMDY5OTVWOC40OTk4Mkg3LjQ5OTk1VjE0LjkyOThIOC40OTk5NVY4LjQ5OTgySDE0LjkyOTlWNy40OTk4MloiIGZpbGw9IiMwMDVFQTYiLz48L3N2Zz4=";